export type SidebarMenuItem = {
 label: string
 id?: string
 link?: string
 type?: "section"
 subItems?: SidebarMenuItem[]
}

export function normalizeSidebarSearch(value: string): string {
 return value
 .normalize("NFD")
 .replace(/[\u0300-\u036f]/g, "")
 .replace(/[\u064B-\u065F\u0670]/g, "")
 .replace(/[أإآٱ]/g, "ا")
 .replace(/ى/g, "ي")
 .replace(/ة/g, "ه")
 .toLocaleLowerCase()
 .trim()
}

function itemMatches(item: SidebarMenuItem, query: string): boolean {
 const normalizedLabel = normalizeSidebarSearch(item.label)
 if (normalizedLabel.includes(query)) return true

 const queryStem = query.endsWith("ه") ? query.slice(0, -1) : query
 return queryStem.length >= 3 && normalizedLabel.includes(queryStem)
}

/**
 * Keeps only matching links while retaining their parent menu and section labels.
 */
export function filterSidebarMenu(
 items: SidebarMenuItem[],
 searchValue: string,
): SidebarMenuItem[] {
 const query = normalizeSidebarSearch(searchValue)
 if (!query) return items

 const filtered: SidebarMenuItem[] = []
 let pendingSection: SidebarMenuItem | null = null

 for (const item of items) {
 if (item.type === "section") {
 pendingSection = item
 continue
 }

 const matchesItem = itemMatches(item, query)
 const subItems = item.subItems
 ? matchesItem
 ? item.subItems
 : filterSidebarMenu(item.subItems, query)
 : undefined
 const hasMatchingSubItems = Boolean(subItems?.some((subItem) => subItem.type !== "section"))

 if (!matchesItem && !hasMatchingSubItems) {
 pendingSection = null
 continue
 }

 if (pendingSection) {
 filtered.push(pendingSection)
 pendingSection = null
 }

 filtered.push({
 ...item,
 ...(item.subItems ? { subItems } : {}),
 })
 }

 return filtered
}
